import axios from 'axios';

const instance = axios.create({
    baseURL: 'http://recibos.sistemacentenario.com.mx:9835'
    //baseURL: 'http://192.168.1.66:9835'
});

export default instance;
